import _arrayWithoutHoles from './arrayWithoutHoles.js';
import _iterableToArray from './iterableToArray.js';
import _unsupportedIterableToArray from './unsupportedIterableToArray.js';
import _nonIterableSpread from './nonIterableSpread.js';

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

export { _toConsumableArray as default };
